import { useStandort } from "../hooks/useStandort";
import { Building2, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function StandortSwitcher() {
  const { standorte, activeStandortId, activeStandort, setActive, loading } = useStandort();

  if (loading || !standorte || standorte.length === 0) return null;
  // Bei genau einem Standort: kein Switcher noetig
  if (standorte.length === 1 && !activeStandortId) return null;

  const label = activeStandort?.name || "Alle Standorte";
  const farbe = activeStandort?.farbe || "#3A4D39";

  return (
    <div className="px-3 py-2 border-b border-stone-100 dark:border-slate-700/30">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            data-testid="standort-switcher-trigger"
            className="w-full flex items-center justify-between gap-2 px-2.5 py-1.5 rounded-sm bg-white/80 dark:bg-slate-800/60 border border-stone-200 dark:border-slate-700 hover:border-[#3A4D39] dark:hover:border-violet-500 transition-colors text-left"
          >
            <div className="flex items-center gap-2 min-w-0">
              <span
                className="w-2 h-2 rounded-full shrink-0"
                style={{ background: farbe }}
              />
              <Building2 size={13} className="text-slate-500 shrink-0" />
              <span className="text-xs font-medium text-[#1A1A1A] dark:text-white truncate">{label}</span>
            </div>
            <ChevronDown size={12} className="text-slate-400 shrink-0" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuLabel className="text-xs">Standort</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => setActive(null)}
            data-testid="standort-option-alle"
            className={!activeStandortId ? "bg-stone-50 dark:bg-slate-800 font-medium" : ""}
          >
            Alle Standorte
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {standorte.map((s) => (
            <DropdownMenuItem
              key={s.id}
              onClick={() => setActive(s.id)}
              data-testid={`standort-option-${s.id}`}
              className={activeStandortId === s.id ? "bg-stone-50 dark:bg-slate-800 font-medium" : ""}
            >
              <span
                className="w-2 h-2 rounded-full mr-2"
                style={{ background: s.farbe || "#3A4D39" }}
              />
              <span className="truncate">{s.name}</span>
              {s.ist_haupt && (
                <span className="ml-auto text-[9px] uppercase text-slate-400">Haupt</span>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
